import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex items-center pt-16">
      <div className="w-full flex flex-col lg:flex-row">
        <div className="w-full lg:w-[40%] flex flex-col justify-center px-6 md:px-10 py-12 lg:py-20">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            {t('hero.headline')}{' '}
            <span className="italic font-normal text-primary-500">
              Spreadsheet & Finds
            </span>
          </h1>
          <p className="mt-4 text-base md:text-lg text-foreground-600 leading-relaxed max-w-lg">
            {t('hero.description')}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              kakobuy sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 border-2 border-primary-500 text-primary-500 px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-primary-500 hover:text-background-50 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap gap-3 mt-10">
            {['trustBadge1', 'trustBadge2', 'trustBadge3', 'trustBadge4'].map((badge) => (
              <span
                key={badge}
                className="inline-flex items-center gap-1.5 text-xs text-foreground-600 bg-background-100 px-3 py-1.5 rounded-full whitespace-nowrap"
              >
                <i className="ri-check-line text-accent-500 text-sm"></i>
                {t(`hero.${badge}`)}
              </span>
            ))}
          </div>
        </div>

        <div className="w-full lg:w-[60%] h-[350px] lg:h-auto lg:min-h-[calc(100vh-64px)] relative">
          <div className="w-full h-full px-6 lg:pl-0 lg:pr-6 pb-6">
            <img
              src="https://readdy.ai/api/search-image?query=Urban%20street%20art%20alley%20with%20colorful%20graffiti%20mural%20on%20weathered%20brick%20wall%2C%20fashion%20sneakers%20and%20streetwear%20clothing%20items%20beautifully%20arranged%20on%20polished%20concrete%20floor%2C%20edgy%20downtown%20city%20vibe%20with%20natural%20afternoon%20light%20streaming%20through%20buildings%2C%20contemporary%20youth%20culture%20aesthetic%2C%20high%20contrast%20editorial%20photography%20with%20cinematic%20color%20grading%20and%20dramatic%20shadows&width=1400&height=1000&seq=hero-collage-v2-2026&orientation=landscape"
              alt="Kakobuy Spreadsheet produkty - moda i akcesoria"
              title="Kakobuy Spreadsheet produkty - moda i akcesoria"
              className="w-full h-full object-cover rounded-[32px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}